module.exports = __webpack_public_path__ + "static/media/freechoice-favico.40d701c6.jpg";